import { UserPanel } from 'src/assets/types/interface/user-panel.interface';

export const user_panel: UserPanel[] = [
  {
    id: 1,
    title: 'Perfil',
    link: '/configuracoes/perfil-empresa',
    context: ['Tomador', 'Prestador'],
  },
  {
    id: 1,
    title: 'Histórico de solicitações',
    link: '/gestao/solicitacoes',
    context: ['Tomador'],
  },
  // {
  //   id: 2,
  //   title: 'Assinatura',
  //   link: '/',
  // },
  // {
  //   id: 3,
  //   title: 'Fatura',
  //   new: true,
  //   link: '/',
  // },
  // {
  //   id: 4,
  //   title: 'Configurações da conta',
  //   link: '/',
  // },
  // {
  //   id: 5,
  //   title: 'Termos de Uso',
  //   link: '/plataform/use-terms',
  // },
  {
    id: 6,
    title: 'Sair',
    link: '/authentication/boxed-login',
    context: ['Tomador', 'Prestador', 'Moderação'],
  },
];
